import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { assessmentScoreActions as slice } from "../slices/assessmentScore";
import { getErrorMessage } from "../../utils/errorUtils";
import { AssessmentScoreBulkRequestDto } from "../../shared/dtos/assessmentScore/AssessmentScoreBulkRequestDto";
import { AssessmentScoreRosterResponseDto } from "../../shared/dtos/assessmentScore/AssessmentScoreRosterResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getAssessmentScoreRoster =
  (assessmentId: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingScoreRoster());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<AssessmentScoreRosterResponseDto[]>
      >("/assessment-scores/roster", {
        headers: { requiresAuth: true },
        params: { assessmentId },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setScoreRoster(data.data));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingScoreRoster(getErrorMessage(error)));
    }
  };

export const saveAssessmentScoreBulk =
  (values: AssessmentScoreBulkRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingScoreBulk());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/assessment-scores/bulk",
        values,
        { headers: { requiresAuth: true } },
      );

      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Scores saved successfully");
        dispatch(slice.saveScoresSuccess());
        dispatch(
          slice.setServerResponseStatus({
            operation: "bulk-save",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorSavingScores(message));
    }
  };

export const resetScoreServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(slice.setServerResponseStatus(null));
};
